import React from "react";
import Header from "../../components/header/Header";
import styles from "./PageNotFoundPage.module.css";

const PageNotFound = () => {
  const showNavigation = false;
  return (
    <div>
      <Header showNavigation={showNavigation} />

      <div className={styles["broken-link-container"]}>
        <p>This link is broken: {window.location.href}</p>
        <p>Please report this broken link to Adways.</p>
        <a href="mailto: support@adways.com">support@adways.com</a>
      </div>
    </div>
  );
};

export default PageNotFound;
